import { createContext, useContext } from "react";
import { IValuePayrollClosing } from "@/Washouts/types/PayrollClosing";

type PayrollClosingContextValue = {
	setHeaderTitle: (title: string) => void;
};

export const PayrollClosingContext = createContext<PayrollClosingContextValue>({
	setHeaderTitle: (_title: string) => {},
});

type PayrollClosingProviderProps = {
	children: JSX.Element;
	value: IValuePayrollClosing;
};

function PayrollClosingProvider(props: Readonly<PayrollClosingProviderProps>) {
	const { children, value } = props;
	return <PayrollClosingContext.Provider value={value}>{children}</PayrollClosingContext.Provider>;
}

function usePayrollClosing() {
	const context = useContext(PayrollClosingContext);
	if (context === undefined) {
		throw new Error("usePayrollClosing must be used within a PayrollClosingProvider");
	}
	return context;
}

export { PayrollClosingProvider, usePayrollClosing };
